module.exports = __webpack_public_path__ + "img/logings6.b708bab2.png";